module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.el, {
    tag: "component",
    attrs: {
      "label": _vm.label,
      "required": _vm.required
    }
  }, [_c('el-cascader', {
    attrs: {
      "placeholder": _vm.placeholder,
      "options": _vm.categories,
      "disabled": _vm.disabled,
      "show-all-levels": _vm.showLevels,
      "filterable": "",
      "props": {
        label: 'label',
        value: 'value'
      },
      "size": _vm.size
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-614c2954"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectEquipCategory.vue
// module id = 1598
// module chunks = 0